// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import VueI18n from 'vue-i18n';
import App from './App';
import { messages, Content } from './trackplus';

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueI18n);
Vue.component('App', App);
Vue.component('Content', Content);

function filter(lang) {
  let name = lang;
  if (name === 'from=groupmessage') { name = 'CN'; }
  return name;
}
const query = filter(window.location.search.substring(1));
const i18n = new VueI18n({
  locale: query.toUpperCase() || 'CN', // set locale
  messages
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  i18n
});



// WEBPACK FOOTER //
// ./src/main.js